import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/notes.svg";
var NotesOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  NotesOutline_default as default
};
